/*
 * Author M. Atoar Rahman
 * Title: D2 Partner Approval
 * Description: Page for D2 Partner Approval
 * Date: 20/06/2022
 */

import { useAuth } from '../../contexts/AuthContext';
import { D2ApprovalProvider } from '../partner/d2Approval/ContextAPI';
import Index from '../partner/d2Approval/Index';
import PermissionDenied from './PermissionDenied';

export default function D2PartnerApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['d2-partner-approval']) return <PermissionDenied />;

    return (
        <D2ApprovalProvider>
            <Index />
        </D2ApprovalProvider>
    );
}
